module.exports = new __parcel__URL__("errorWarning.3a015e54.svg").toString();